import React from 'react';
import LeftSide from '../main/left-side';
import Navbar from '../navigation/navbar';
import { Col, Row } from 'react-bootstrap';
import TitleCard from '../main/title-card';
import { Link } from 'react-router';
import useTranslate from '../useTranslate';
import RolesAddUserCard from './roles-add-user-card';
import RolesInfoCard from './roles-info-card';

function RolesInviteWrapper() {
    const strings = useTranslate('RolesInviteWrapper');
    return (
        <Navbar nav>
            <Row>
                <LeftSide>
                    <TitleCard
                        title={strings.title}
                        left={{
                            content: (
                                <Link
                                    to={'/roles'}
                                    className="icon icon-wew-arrow-left icon-sm"
                                />
                            ),
                            title: strings.back,
                        }}
                    />
                </LeftSide>
                <Col xs={9} className={'col-middle'}>
                    <Row>
                        <Col xs={8} sm={8} md={8} lg={8}>
                            <RolesAddUserCard />
                        </Col>
                        <Col xs={4} sm={4} md={4} lg={4}>
                            <RolesInfoCard />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Navbar>
    );
}

export default RolesInviteWrapper;
